import { bookLoaded } from "../../books/action";

const searchFilter = (values) => {
  const { search } = values;
  return async (dispatch) => {
    const response = await fetch("http://localhost:9000/books");
    const books = await response.json();
    
    const filteredData = books.filter((item) =>
      item.name.toLowerCase().includes(search.toLowerCase())
    );
    dispatch(bookLoaded(filteredData));
  };
};

export default searchFilter;
